import type { ReactElement } from 'react';

import { Karte } from '../../../components/Karte';

/**
 * Stimme abgegeben (§13.1, §13.2, §19.2).
 *
 * Zeigt die Erfolgsbestätigung — und **niemals** die getroffene Auswahl. Der Server liefert sie
 * gar nicht mehr mit; es gibt keine Quittung, aus der die konkrete Wahl hervorginge (§13.2).
 */
export function StimmeAbgegebenAnsicht(): ReactElement {
  return (
    <Karte className="text-center">
      <p className="text-erfolg text-lg font-semibold">Ihre Stimme wurde gezählt.</p>

      <p className="text-text-gedaempft mt-3 text-sm">
        Die Abstimmung ist geheim: Ihre Auswahl wird nicht angezeigt und lässt sich niemandem
        zuordnen — auch der Verwaltung nicht.
      </p>

      <p className="mt-3 text-sm">
        Eine weitere Stimme ist in dieser Abstimmung nicht möglich. Bitte warten Sie, bis die
        Abstimmung geschlossen wird.
      </p>
    </Karte>
  );
}
